<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import axios from 'axios'
    import moment from 'moment'

    import VirtualList from '../../components/VirtualList/VirtualList.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    // import FadeinFX from '../../components/FX/FadeinFx.svelte';


    export let sectorId
    export let date
    export let height = '390px'
    
    let items = null


    const dispatch = createEventDispatcher ();

    onMount (() => {
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'post',
            url: '/api/programs/listOperators/' + sectorId + (date ? `?date=${date}` : '')
        }).then (result => {
            items = result.data.map (it => {
                if (it.holiday && it.holiday.start && it.holiday.end) {
                    const holiday_start = moment(it.holiday.start).format('DD/MM')
                    const holiday_end = moment(it.holiday.end).format('DD/MM')
                    it.holiday.startHR = holiday_start;
                    it.holiday.endHR = holiday_end;
                }
                return it
            })
            dispatch ('app-event', { id: 'background', value: false });
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    })
</script>

<style>
    .ListChooser :global(svelte-virtual-list-viewport) {
        padding: 10px;
    }
    .OperatorItem.holiday :global(.ListItem) {
        background-color: #ffc6c6;
    }
    .OperatorItem.holiday .meta .txt {
        color: var(--panel-fg);
    }
</style>

{#if items}
    <div class="ListChooser">
        <!-- <FadeinFX durationOut={0}> -->
            <VirtualList {items} {height} let:item>
                <div class="OperatorItem clearfix" class:holiday={item.holiday !== undefined}>
                    <ListItem classes="block with-icon clearfix" actions on:click={e => dispatch ('select', item)}>
                        <div class="icon">
                            <i class="fad fa-user-hard-hat"></i>
                        </div>
                        <div class="meta">
                            <div class="lbl">{item.name}</div>
                            <div class="txt">
                                {#if item.holiday}
                                    In 
                                    {#if item.holiday.type === 0}
                                        ferie
                                    {:else if item.holiday.type === 1}
                                        permesso
                                    {:else}
                                        malattia
                                    {/if}
                                    dal {item.holiday.startHR} al {item.holiday.endHR}
                                {:else}
                                    {item.username}
                                {/if}
                            </div>
                        </div>
                        
                        <div slot="actions">
                            <ActionButton icon="far fa-arrow-left" on:click={e => dispatch ('select', item)} />
                        </div>
                    </ListItem>
                </div>
            </VirtualList>
        <!-- </FadeinFX> -->
    </div>
{/if}